/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { USState } from './USState';

export type LegacyMatchConflictIssueDto = {
  group: LegacyMatchConflictIssueDto.group;
  state: USState;
  issuerIds: Array<string>;
  /**
   * The legacy row the match takes: its name, and for an Echo row its state in parentheses, as in candidates
   */
  chosen: string;
  candidates: Array<string>;
};
export namespace LegacyMatchConflictIssueDto {
  export enum group {
    CONTEXT = 'context',
    ECHO = 'echo',
  }
}
